import React from "react";
import { addMessageListener, removeMessageListener } from "../../utils/app/appUtils"

const RN_APP_API_TYPE =  {
  GET_DEVICE_STATE : "GET_DEVICE_STATE",
  MOVE_EXTERNAL_LINK : "MOVE_EXTERNAL_LINK",
  OPEN_SHARE : "OPEN_SHARE",
  CHANGE_PUSH_PERMISSION : "CHANGE_PUSH_PERMISSION",
  MOVE_PUSH_LINK : "MOVE_PUSH_LINK",
  MOVE_DEEP_LINK : "MOVE_DEEP_LINK",
  GET_APP_VERSION : "GET_APP_VERSION",
  GET_APP_CURRENT_VERSION : "GET_APP_CURRENT_VERSION",
  GET_APP_LATEST_VERSION : "GET_APP_LATEST_VERSION",
  SHOW_LOADING_VIEW : "SHOW_LOADING_VIEW",
  HIDE_LOADING_VIEW : "HIDE_LOADING_VIEW",
  REQUEST_APP_FILE : "REQUEST_APP_FILE",
  OPEN_SETTINGS : "OPEN_SETTINGS",
  OPEN_CONFIRM_ALERT : "OPEN_CONFIRM_ALERT",
  CHECK_DEEP_LINK : "CHECK_DEEP_LINK",
  GO_BACK : "GO_BACK",
  LOAD_INTERNAL_LINK : "LOAD_INTERNAL_LINK",
  BACK_COUNT_INITIAL : "BACK_COUNT_INITIAL"
};

const getReqId = function() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  }
  return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
};

const WebviewMessage = async (type, data) =>
  new Promise((resolve, reject) => {
    if (!window.ReactNativeWebView) {
      reject('ReactNativeWebView 객체가 없습니다.');
      return;
    }

    const reqId = getReqId();
    const TIMEOUT = 3000; // 3 * 1000 = 3s
    const timer = setTimeout(() => {
      removeMessageListener(listener);
      reject('TIMEOUT');
    }, TIMEOUT);
    const listener = (event) => {
      const { data: listenerData, reqId: listenerReqId } = JSON.parse(event.data);
      if (listenerReqId === reqId) {
        clearTimeout(timer);
        removeMessageListener(listener);
        resolve(listenerData);
      }
    };
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        type,
        data,
        reqId
      })
    );
    addMessageListener(listener);
  });

export default WebviewMessage;
export { RN_APP_API_TYPE };
